import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { endpoints } from "../lib/api";
import * as store from "../lib/storage";

const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);

export function AppProvider({ children }) {
  const [auth, setAuth] = useState({ authenticated: false, loading: true });
  const [saved, setSaved] = useState(store.getSaved());
  const deviceId = store.getDeviceId();

  const refreshAuth = useCallback(async () => {
    try {
      const me = await endpoints.me();
      setAuth({ ...me, loading: false });
    } catch {
      setAuth({ authenticated: false, loading: false });
    }
  }, []);

  useEffect(() => { refreshAuth(); }, [refreshAuth]);

  const toggleSave = useCallback((project) => {
    const nowSaved = store.toggleSaved(project);
    setSaved(store.getSaved());
    return nowSaved;
  }, []);

  const signOut = useCallback(async () => {
    await endpoints.signout();
    setAuth({ authenticated: false, loading: false });
  }, []);

  return (
    <AppCtx.Provider value={{ auth, refreshAuth, signOut, saved, toggleSave, isSaved: store.isSaved, deviceId }}>
      {children}
    </AppCtx.Provider>
  );
}
